import React, { useContext } from 'react';
import { makeStyles } from '@fluentui/react-components';
import WorkspaceContext from '../Context/WorkspaceContext';
import { Pill, PillContainer, PillType } from '../Pill/Pill';

const useStyles = makeStyles({
  container: {
    minWidth: '165px',
  },
});

/**
 * Provide a pair of 'pill' elements displaying the current row count and selected row counts.
 */
const GridToolbarWorkspaceRowCounter = () => {
  const { rowCount, selectedRowCount } = useContext(WorkspaceContext);

  const styles = useStyles();

  return (
    <PillContainer className={styles.container}>
      <Pill type={PillType.Info}>{`${rowCount} Rows`}</Pill>
      <Pill
        type={(selectedRowCount ?? 0) > 0 ? PillType.Warning : PillType.Info}
      >{`${selectedRowCount} Selected`}</Pill>
    </PillContainer>
  );
};

export default GridToolbarWorkspaceRowCounter;
